function ResizeEvents() {

	var timer,
		orientationchanged = true,
		newOrientation,
		$window = $(window),
		oldOrientation = $window.width() > $window.height() ? 'landscape' : 'portrait';

	$window.resize(function () {
		if (timer) {
			clearTimeout(timer);
		}

		timer = setTimeout(function () {
			if (mobileCheck.isMobile) {
				newOrientation = $window.width() > $window.height() ? 'landscape' : 'portrait';
				orientationchanged = newOrientation !== oldOrientation;
				oldOrientation = newOrientation;
				if (!orientationchanged) {
					$window.trigger('mobileResize');
				}
			}

			if (orientationchanged) {
				$window.trigger('customResize');
			}
		}, 100);
	});

	$window.on('customResize', function () {
		var previousY = currentY;

		// if (!mobileCheck.isMobile) {
		// 	scrollBar.scrollTo(0, 0);
		// }

		resizeCallbacks.forEach(function (callback) {
			callback.resize();
		});

		// if (!mobileCheck.isMobile) {
		// 	// Restauration du scroll
		// 	scrollBar.scrollTo(0, previousY);
		// }
	});

	$window.on('mobileResize', function () {
		mobileResizeCallbacks.forEach(function (callback) {
			callback.resize();
		});
	});
}
